<ng-container *ngIf="loading === true; else loadedTemplate">
  <mat-card-subtitle style="margin-top: 16px;">
    Loading payment methods for your store...
  </mat-card-subtitle>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>
<ng-template #loadedTemplate>
  <mat-card-subtitle style="margin-top: 16px;">
    Select a payment method
  </mat-card-subtitle>
  <form class="dynamic-form" [formGroup]="form" style="width: 100%">
    <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

      <mat-form-field fxFlex="50" width="100%">
        <mat-label>Store</mat-label>
        <mat-select formControlName="storeId" (selectionChange)="storeChanged()">
          <mat-option *ngFor="let store of stores" [value]="store.storeId">
            {{store.storeName}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field fxFlex="50" width="100%">
        <mat-label>Container</mat-label>
        <mat-select formControlName="containerId" (selectionChange)="containerChanged()">
          <mat-option *ngFor="let container of containers" [value]="container.containerId">
            {{container.containerDesc}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <ng-container *ngIf="form.value.containerId">
        <div fxFlex="100" width="100%">


          <ng-container *ngIf="hasOpenBatch; else noOpenBatch">
            <ng-container [ngSwitch]="equipmentTypeCode">
              <app-pos-payment-cash (formChanged)="formChanged($event)" [containerDesc]="containerDesc" [storeId]="form.value.storeId"
                [equipmentTypeCode]="equipmentTypeCode" [amountOutstanding]="amountOutstanding" [totalOrderOutstanding]="totalOrderOutstanding" [paymentType]="paymentType"
                [containerId]="form.value.containerId" *ngSwitchCase="'CASHDRAWER'">
              </app-pos-payment-cash>
              <app-pos-payment-card (formChanged)="formChanged($event)" [containerDesc]="containerDesc" [storeId]="form.value.storeId"
                [equipmentTypeCode]="equipmentTypeCode" [amountOutstanding]="amountOutstanding" [paymentType]="paymentType"
                [containerId]="form.value.containerId" *ngSwitchCase="'CCMACHINE'">
              </app-pos-payment-card>
              <app-pos-payment-eft (formChanged)="formChanged($event)" [containerDesc]="containerDesc" [storeId]="form.value.storeId"
                [equipmentTypeCode]="equipmentTypeCode" [amountOutstanding]="amountOutstanding" [paymentType]="paymentType"
                [containerId]="form.value.containerId" *ngSwitchCase="'BANKACC'">
              </app-pos-payment-eft>
              <app-pos-payment-tfg-vision (formChanged)="formChanged($event)" [containerDesc]="containerDesc" [storeId]="form.value.storeId"
                [equipmentTypeCode]="equipmentTypeCode" [amountOutstanding]="amountOutstanding" [paymentType]="paymentType"
                [containerId]="form.value.containerId" [salesOrderNumber]="salesOrderNumber" [invoiceNumber]="invoiceNumber" *ngSwitchCase="'TFGVISION'">
              </app-pos-payment-tfg-vision>
              <app-pos-payment-ozow (formChanged)="formChanged($event)" [containerDesc]="containerDesc" [storeId]="form.value.storeId"
                [equipmentTypeCode]="equipmentTypeCode" [amountOutstanding]="amountOutstanding" [paymentType]="paymentType"
                [containerId]="form.value.containerId" *ngSwitchCase="'OZOW'">
              </app-pos-payment-ozow>
              <app-pos-payment-zapper (formChanged)="formChanged($event)" [containerDesc]="containerDesc" [storeId]="form.value.storeId"
                [equipmentTypeCode]="equipmentTypeCode" [amountOutstanding]="amountOutstanding" [paymentType]="paymentType"
                [containerId]="form.value.containerId" *ngSwitchCase="'ZAPPER'">
              </app-pos-payment-zapper>
              <app-pos-payment-rcs (formChanged)="formChanged($event)" [containerDesc]="containerDesc" [storeId]="form.value.storeId"
                [equipmentTypeCode]="equipmentTypeCode" [amountOutstanding]="amountOutstanding" [paymentType]="paymentType"
                [containerId]="form.value.containerId" *ngSwitchCase="'RCSCARD'">
              </app-pos-payment-rcs>
              <app-pos-payment-payjustnow (formChanged)="formChanged($event)" [containerDesc]="containerDesc" [storeId]="form.value.storeId"
                [equipmentTypeCode]="equipmentTypeCode" [amountOutstanding]="amountOutstanding" [paymentType]="paymentType"
                [containerId]="form.value.containerId" *ngSwitchCase="'PAYJUSTNOW'">
              </app-pos-payment-payjustnow>
              <app-pos-payment-yoyo (formChanged)="formChanged($event)" [containerDesc]="containerDesc" [storeId]="form.value.storeId"
                [equipmentTypeCode]="equipmentTypeCode" [amountOutstanding]="amountOutstanding" [paymentType]="paymentType"
                [containerId]="form.value.containerId" [salesOrderNumber]="salesOrderNumber" [invoiceNumber]="invoiceNumber" *ngSwitchCase="'YOYO'">
              </app-pos-payment-yoyo>
              <ng-container *ngSwitchDefault>{{equipmentTypeCode}} is not supported!</ng-container>

            </ng-container>
          </ng-container>
          <ng-template #noOpenBatch>
            <div style="display: flex;flex-direction: column;align-content: center;align-items: center;background-color: tomato;border-radius: 5px;font-weight: 500;">
              <p>The "drawer" for {{containerDesc}} is not open yet.</p>
              <p>Please open the drawer first before capturing a payment for this payment method.</p>
            </div>
          </ng-template>



        </div>
      </ng-container>

      <mat-form-field *ngIf="refundReasons.length > 0" fxFlex="100" width="100%">
        <mat-label>Refund Reason</mat-label>
        <mat-select formControlName="refundReasonId" (selectionChange)="onRefundReasonChanged()">
          <mat-option *ngFor="let refundReason of refundReasons" [value]="refundReason.refundReasonId">
            {{refundReason.refundReasonDesc}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</ng-template>




